import React from 'react';
import { errorCatch, POST, deleteInArray, GET, updateInArray, getLocator } from 'fennec-ui'
import { CollectionServer } from 'fennec-ui';
import AddControllerMeropriyatie from '../AddControllerMeropriyatie';
import User from '../../../common/User';
import ModernUserSelection from '../../components/ModernUserSelection';

var _ = require('lodash');

export default function ControllersMeropriyatiya(props) {
    const { auth, object } = props;
    const filters = () => [
        {
            label: "Идентификатор пользователя",
            name: "user.ID",
            sort: true,
            filter: true,
        },
        {
            name: "user.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "user.firstname",
            sort: true,
            filter: true,
        },
        {
            name: "user.patronymic",
            sort: true,
            filter: true,
        },
        {
            name: "user.email",
            sort: true,
            filter: true,
        },
        {
            label: "Телефон",
            name: "user.phone",
            sort: true,
            filter: true,
        },
        {
            name: "user.gender",
            sort: true,
            filter: true,
        },
        {
            label: "Дата регистрации",
            name: "user.createdAt",
            type: "date",
            sort: true,
            filter: true,
        },
        {
            label: "Дата назначения",
            name: "createdAt",
            type: "date",
            sort: true,
            filter: true,
        }
    ];
    const render = (item, idx, { setCollection, setCollectionItem, update }) => {
        return (<div key={idx} style={{ width: "100%" }} className="clickable">
            <User item={item.polzovatel} />
        </div>)
    }
    return (
        <>
            <CollectionServer
                name={"Controllers"}
                auth={auth}
                size="small"

                source={`/api/controllers/bymeropriyatie/${object.ID}`}
                filters={filters}

                mode={"list"}
                render={render}

                onItemLocator={(item, index) => {
                    return getLocator("Controller-" + item?.polzovatel?.email);
                }}

                collectionActions={() => [
                    {
                        action: {
                            method: "POST",
                            path: "/api/controllers/new",
                            mutation: "update",
                            onValues: (values) => {
                                return { polzovatelID: values.polzovatel.ID, meropriyatieID: object.ID }
                            },
                            onClose: ({ close }) => {
                                close();
                            }
                        },
                        triggerOptions: {
                            type: "primary"
                        },
                        // form: AddControllerMeropriyatie,
                        form: ModernUserSelection,
                        options: {
                            initialValues: {},
                        },
                        title: "Добавить контролера",
                        modal: {
                            minWidth: "250px",
                            title: "Новый контролер",
                        }
                    }
                ]}
                modelActions={(item) => [
                    {
                        title: "Удалить",
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POST(auth, '/api/controllers/delete', { ...item },
                                () => setCollection(deleteInArray(collection, item)), errorCatch
                            );
                        },
                    }
                ]}
            />
        </>
    );
}
